import React, { useState } from "react"
import { useTranslation } from 'react-i18next'
import "./worksNotice.scss"

const WorksNotice = () => {
  const { t } = useTranslation('common')
  const [visible, setVisible] = useState(true)

  if (!visible) return null

  return (
    <div className="works-notice">
      <div className="works-notice__inner">
        <svg className="works-notice__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 21h5" />
          <path d="M6.5 21V3" />
          <path d="M6.5 5.5L19 10" />
          <path d="M17.5 9v9" />
          <path d="M14.5 21h8" />
          <circle cx="17.5" cy="19.5" r="1.5" />
        </svg>
        <span className="works-notice__text">{t('Works notice')}</span>
        <button type="button" className="works-notice__close" onClick={() => setVisible(false)} aria-label={t('Close') as string}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
            <path d="M1 1l10 10M11 1L1 11" />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default WorksNotice
